import React, { useMemo, useState, useEffect } from "react";
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

export default function Empresas() {
  const [q, setQ] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  
 // const navigate = useNavigate(); 

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    authFetch('/api/lugar')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Error al cargar empresas: ' + res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        setEmpresas(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setEmpresas([]);
        setLoading(false);
      });
  }, []); 

  
  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return empresas; 
    
    return empresas.filter(r =>
      [r.nombre, r.telefono, r.correoElectronico].some(v => 
        String(v).toLowerCase().includes(t)
      )
    );
  }, [q, empresas]);


 // const handleEditar = (empresa) => {
 //   navigate(`/admin/empresas/editar/${empresa.id}`);
 // };

  const handleDelete = async (empresa) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar la empresa "${empresa.nombre}"?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const response = await authFetch(`/api/lugar/${empresa.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar la empresa.');
      }
      
      setEmpresas(prevEmpresas => 
        prevEmpresas.filter(p => p.id !== empresa.id)
      );

      alert('Empresa eliminada exitosamente.');

    } catch (err) {
      alert(`Error al eliminar: ${err.message}`);
    }
  };


  return (
    <main className="aseg-main">

      {/* Encabezado con título */}
      <header className="aseg-header">
        <h1 className="aseg-title">Empresas</h1>
      </header>

      <SearchInput
              placeholder="Buscar empresas por nombre, tel"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
      


      {loading && <p>Cargando empresas...</p>}
      
      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}
      
      {!loading && !error && (

        <div className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo electrónico</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td className="td-acciones">
                        {/* Botón de Borrar */}
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      {q 
                        ? 'No se encontraron empresas que coincidan con la búsqueda' 
                        : 'No hay empresas registradas.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
}